import React from 'react';

const OPTIONS = [
    { title: 'Accomplished', description: '< 6 Years', key: 'wants_junior_experience' },
    { title: 'Advanced', description: '6-10 Years', key: 'wants_intermediate_experience' },
    { title: 'Expert', description: '11+ Years', key: 'wants_senior_experience' },
]

const ExperienceGroup = (props) => {
    // let options = laravel.talent_experience_levels;
    // let minOptionSelected = options[props.minSelected];

    return (
        <div className="-mx-2 sm:flex mt-4">

            {OPTIONS.map((option, key) => {
                const active = props[option.key];
                return (
                    <div
                        key={option.title}
                        className={TB.mapClass("experience-tile-select relative flex my-3 sm:my-0 items-center border mx-2 gap-3 px-4 py-3 rounded-lg flex-1 disabled:pointer-events-none", {
                            active,
                            disabled: props.disabled,
                            clickable: TB.isDefined(props.onClick),
                            "border-danger": props.formError,
                        })}
                        onClick={() => {
                            if (props.onClick) {
                                return props.onClick(key)
                            }
                        }}
                    >
                        {active ?
                            <i className="fas fa-check-square text-success" />
                            : <i className="far fa-square" />
                        }
                        <div className="flex gap-1 flex-col">
                            <h6 className="font-bold mb-0">{option.title}</h6>
                            <p className="text-sm mb-0">{option.description}</p>
                        </div>
                    </div>
                )
            })}
        </div>
    )
};

export default ExperienceGroup;
